import { render, staticRenderFns } from "./SublessonTableItem.vue?vue&type=template&id=7f5f4f63&scoped=true&"
import script from "./SublessonTableItem.vue?vue&type=script&lang=ts&"
export * from "./SublessonTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./SublessonTableItem.vue?vue&type=style&index=0&id=7f5f4f63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5f4f63",
  null
  
)

export default component.exports